export const PDF_COLORS = {
  gold: "#9a7b2e",
  goldLight: "#c9a84c",
  text: "#1a1a1a",
  muted: "#555555",
  border: "#d8d0bc",
  panelBg: "#faf7f0",
  white: "#ffffff",
};

export const PDF_PAGE_MARGINS = [45, 45, 45, 45];

export const PDF_STYLES = {
  brandName: {
    fontSize: 8,
    bold: true,
    color: PDF_COLORS.gold,
    characterSpacing: 2,
    margin: [0, 0, 0, 2],
  },
  docTitle: {
    fontSize: 14,
    bold: true,
    color: PDF_COLORS.text,
    margin: [0, 0, 0, 0],
  },
  companyTagline: {
    fontSize: 8,
    color: PDF_COLORS.muted,
    margin: [0, 2, 0, 0],
  },
  panelTitle: {
    fontSize: 8,
    bold: true,
    color: PDF_COLORS.gold,
    characterSpacing: 1,
    margin: [0, 0, 0, 6],
    alignment: "left",
  },
  metaLabel: {
    fontSize: 7,
    bold: true,
    color: PDF_COLORS.muted,
    characterSpacing: 0.5,
    margin: [0, 0, 0, 0],
    alignment: "left",
    lineHeight: 1.25,
  },
  metaValue: {
    fontSize: 9,
    bold: false,
    color: PDF_COLORS.text,
    alignment: "left",
    lineHeight: 1.25,
  },
  sectionTitle: {
    fontSize: 8.5,
    bold: true,
    color: PDF_COLORS.gold,
    characterSpacing: 1,
    margin: [0, 0, 0, 8],
  },
  subsectionTitle: {
    fontSize: 8,
    bold: true,
    color: PDF_COLORS.muted,
    margin: [0, 6, 0, 4],
  },
  body: {
    fontSize: 9,
    color: PDF_COLORS.text,
    lineHeight: 1.25,
  },
  itemName: {
    fontSize: 8.5,
    bold: false,
    color: PDF_COLORS.text,
  },
  itemDetail: {
    fontSize: 7.5,
    color: PDF_COLORS.muted,
    margin: [0, 1, 0, 0],
  },
  itemAmount: {
    fontSize: 8.5,
    bold: true,
    alignment: "right",
  },
  locationName: {
    fontSize: 10,
    bold: true,
    color: PDF_COLORS.text,
    margin: [0, 8, 0, 4],
  },
  workTypeName: {
    fontSize: 9,
    bold: true,
    color: PDF_COLORS.text,
    margin: [0, 6, 0, 2],
  },
  tableHeader: {
    fontSize: 7.5,
    bold: true,
    color: PDF_COLORS.muted,
    fillColor: PDF_COLORS.panelBg,
  },
  tableCell: {
    fontSize: 8.5,
    color: PDF_COLORS.text,
  },
  totalsRow: {
    fontSize: 8.5,
    color: PDF_COLORS.text,
    margin: [0, 2, 0, 2],
  },
  totalsSubtotal: {
    fontSize: 8.5,
    bold: true,
    color: PDF_COLORS.text,
    margin: [0, 4, 0, 2],
  },
  totalsGrand: {
    fontSize: 10,
    bold: true,
    color: PDF_COLORS.gold,
    margin: [0, 6, 0, 0],
  },
  notes: {
    fontSize: 8.5,
    color: PDF_COLORS.text,
    lineHeight: 1.3,
  },
  invoiceFooter: {
    fontSize: 8,
    color: PDF_COLORS.muted,
    lineHeight: 1.35,
  },
  footer: {
    fontSize: 7.5,
    color: PDF_COLORS.muted,
  },
  summaryCardLabel: {
    fontSize: 7,
    bold: true,
    color: PDF_COLORS.gold,
    alignment: "center",
    margin: [0, 0, 0, 6],
  },
  summaryCardValue: {
    fontSize: 14,
    bold: true,
    color: PDF_COLORS.text,
    alignment: "center",
  },
  summaryCardValueEmphasis: {
    fontSize: 14,
    bold: true,
    color: PDF_COLORS.gold,
    alignment: "center",
  },
};

export function pdfGoldRule(contentWidth = 522) {
  return {
    canvas: [
      {
        type: "line",
        x1: 0,
        y1: 0,
        x2: contentWidth,
        y2: 0,
        lineWidth: 1,
        lineColor: PDF_COLORS.goldLight,
      },
    ],
    margin: [0, 8, 0, 8],
  };
}
